import axios from "../plugins/axios";

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const getUserRoles = ({ email, userId }) =>
    axios.get(`${apiUrl}/getuserroles?useremail=${email}&userId=${userId}`);

const updateUserRoles = (dto) => axios.post(`${apiUrl}/updateuserroles`, dto);

const userRoleService = {
    getUserRoles,
    updateUserRoles,
};

export default userRoleService;
